module.exports = __webpack_public_path__ + "img/亮点1_03.deecbe00.jpg";